import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import get from 'lodash/get';
import { ChangeEvent, ReactElement } from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';

import styles from './RadioGroup.module.scss';

interface IOption {
  value: string | number | boolean;
  label: string;
  disabled?: boolean;
}

interface IProps {
  control: Control<any>;
  errors: FieldErrors;
  name: string;
  options: IOption[];
  label?: string;
  className?: string;
  tabIndex?: number;
  size?: 'small' | 'medium';
  unselectable?: boolean;
  defaultValue?: string | number | readonly string[];
  cb?: (value?: string) => void;
}

const RadioGroupComponent = ({
  control,
  errors,
  name,
  options,
  label = '',
  className,
  tabIndex,
  size,
  unselectable,
  defaultValue,
  cb,
}: IProps): ReactElement => {
  const error = get(errors, `${name}.message`, '');

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value = defaultValue, onChange } }) => (
        <FormControl component="div" className={className}>
          <FormLabel component="div" className={styles.label}>
            {label}
          </FormLabel>
          <RadioGroup
            aria-label="gender"
            value={value}
            defaultValue={defaultValue}
            className={styles.radioGroup}
            onChange={(event: ChangeEvent<HTMLInputElement>, v: string) => {
              cb?.(v);
              onChange(event, v);
            }}
          >
            {options.map((option, index) => (
              <FormControlLabel
                tabIndex={tabIndex ? tabIndex + index : undefined}
                key={option.label}
                value={option.value}
                control={
                  <Radio
                    color="primary"
                    size={size}
                    checked={value === option.value}
                    onClick={() => {
                      if (unselectable && value === option.value) {
                        onChange('');
                      }
                    }}
                  />
                }
                label={option.label}
                disabled={option.disabled}
              />
            ))}
          </RadioGroup>
          {error && <FormHelperText error>{error.toString()}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};

export default RadioGroupComponent;
